import * as React from 'react';
import { useSelector } from 'react-redux';

import { LinksBlock } from '../../components/LinksBlock';
import { IApplicationState } from '../../types/redux';
import { LINKS, LINKS_ORDER_DEFAULT } from '../../constants/links';

export const LinksBlockContainer: React.FC = () => {
  const state = useSelector((state: IApplicationState) => state);

  const availableLinksComponents = LINKS_ORDER_DEFAULT.reduce((acc, linkKey) => {
    const { component: Component, availability } = LINKS[linkKey];
    if (!availability || (availability && availability(state))) {
      acc.push(<Component linkKey={linkKey} />);
    }

    return acc;
  }, [] as React.ReactNode[]);

  return <LinksBlock links={availableLinksComponents} />;
};
